import React from 'react';
import { Rate } from 'antd';
import { SupplierReview } from '@/shared/types/catalog';
import dayjs from 'dayjs';
import s3ImageTransform from '@/shared/utils/s3ImageTransform';
import Image from 'next/image';
import { convertReviewScoreToScale } from '@/shared/utils/sourcing-marketplace-util';
import { isEmpty } from 'lodash-es';
import './index.less';

interface IProps {
  review: SupplierReview;
}

const ReviewDetails = ({ review }: IProps) => {
  return (
    <div className="review-details">
      <div className="buyer">
        <h2 className="name">{review.buyerName}</h2>
        <span className="date">{dayjs(review.createdAt).format('MMMM DD, YYYY')}</span>
      </div>
      <Rate style={{ color: '#ff5c3c' }} value={convertReviewScoreToScale(review.score)} disabled allowHalf></Rate>
      <div className="content">{review.content}</div>
      {!isEmpty(review.images) && (
        <div className="img-box">
          {review.images.map((img: string, i: number) => (
            <Image key={i} src={s3ImageTransform(img, 'large')} width={64} height={64} alt="review" />
          ))}
        </div>
      )}
    </div>
  );
};

export default ReviewDetails;
